<template>
  <div>
    <a-tabs :active-key="activeKey" @change="changeTab">
      <a-tab-pane
        v-for="item in tabs"
        :key="item.routeName"
        :tab="item.tabName"
      >
        <router-view v-if="activeKey === item.routeName" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
export default {
  name: 'AllocationRecordsShowTab',
  data() {
    return {
      activeKey: '',
      tabs: [
        { routeName: 'allocation_records', tabName: '卡号划拨' },
        { routeName: 'allocation_records_esims', tabName: 'eSIM划拨' },
        { routeName: 'allocation_records_profiles', tabName: 'Profile划拨' },
        { routeName: 'allocation_records_modules', tabName: '模组划拨' },
        { routeName: 'allocation_records_cpes', tabName: 'CPE划拨' }
      ]
    }
  },
  watch: {
    $route: {
      handler(route) {
        this.activeKey = route.name
      }
    }
  },
  created() {
    this.activeKey = this.$route.name
  },
  methods: {
    changeTab(activeKey) {
      this.activeKey = activeKey
      this.$router.push({ name: activeKey })
    }
  }
}
</script>
